import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import "./App.css";

import Header from "./components/Header";
import Home from "./pages/Home";
import ProjectDetail from "./pages/ProjectDetail";
import About from "./pages/About";
import CV from "./pages/CV";
import Contact from "./pages/Contact";

function App() {
  useEffect(() => {
    document.documentElement.lang = "he";
    document.documentElement.dir = "rtl";
  }, []);

  return (
    <div className="App grain min-h-screen">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/about" element={<About />} />
          <Route path="/cv" element={<CV />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="*" element={<Home />} />
        </Routes>
        <Toaster
          position="top-center"
          dir="rtl"
          toastOptions={{
            style: {
              background: "#0F0F0F",
              color: "#FDFCF8",
              border: "1px solid #0F0F0F",
              fontFamily: "Heebo, sans-serif",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
